import { c as _c } from "react/compiler-runtime";
import { authorizeUser, getAttributionStatus, newEventByName } from "@metrixorg/websdk";
import { useJwtToken } from "@website/hooks/auth-manager";
import { WebengageLoginType } from "@website/tracking/tracking.types";
import { getChannel } from "@website/utils/channel/get-channel";
import { isChannel } from "@website/utils/channel/helpers";
import toString from "lodash-es/toString";
export const useWebengage: WebengageLoginType = () => {
  const $ = _c(7);
  const {
    userPushId,
    phoneNumber,
    name,
    sub
  } = useJwtToken();
  let login;
  if ($[0] !== name || $[1] !== phoneNumber || $[2] !== sub || $[3] !== userPushId) {
    login = guestUserPhone => {
      const phone = toString(phoneNumber || guestUserPhone);
      if (isChannel(["android"]) && sub) {
        authorizeUser(sub);
        getAttributionStatus().then(status => {
          newEventByName("USER_LOGGED_IN", {
            userID: toString(sub),
            channel: getChannel(),
            attributionStatus: toString(status?.attributionStatus)
          });
        });
      }
      if (!window.webengage) {
        setTimeout(login, 1000);
        return;
      }
      userPushId && window.webengage.user.login(userPushId);
      phone && window.webengage.user.setAttribute("we_phone", phone);
      name && window.webengage.user.setAttribute("we_first_name", name);
      phone && window.webengage.user.setAttribute("random-usernumber", Number(phone.slice(-1)));
    };
    $[0] = name;
    $[1] = phoneNumber;
    $[2] = sub;
    $[3] = userPushId;
    $[4] = login;
  } else {
    login = $[4];
  }
  let t0;
  if ($[5] !== login) {
    t0 = {
      login
    };
    $[5] = login;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  return t0;
};